<template>
    <div>
        <nav-breadcrumb :menu="[{label: ' 他项权证查询'}]"/>
        <el-tabs v-model="status">
            <el-tab-pane label="已入库" name="IN" />
            <!-- <el-tab-pane label="审核通过" name="Approved" />-->
            <el-tab-pane label="已出库" name="OUT" />
        </el-tabs>
        <div class="xzpadd10 bg-purple of">
            <data-table
                :table-data="tableData"
                :columns="columns"
                :page.sync="page"
                :pageSize.sync="pageSize"
                :filters.sync="filters"
                :actions="actions"
            />
        </div>
        <el-dialog title="出入库明细" :visible.sync="dialogVisible" width="90%">
            <data-table :table-data="planData" :columns="columns1" :is-pagination-show="false"></data-table>
        </el-dialog>

    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import Status2CN from "../../filters/Status2CN";
    import {removeItem} from "../../filters/CommonActions";
    import moment from 'moment'
    export default {
        name: "HisWarrantList",
        data(){
            return{
                dialogVisible:false,
                status: 'IN',
                columns:[
                    {
                        type: 'index'
                    },
                    {
                        label: '他项权证号',
                        field: 'w__hisWarrantNo'
                    },
                    {
                        label: '客户姓名',
                        field: 'w__customerName'
                    },
                    {
                        label: '贷款编号',
                        field: 'w__transactionNo'
                    },
                    {
                        label: '出/入库日期',
                        field: 'w__checkoutTime',
                        formatter: function (r,c,v) {
                            return moment(v||new Date()).format('YYYY-MM-DD')
                        }
                    },
                    {
                        label: '状态',
                        field: 'w__status',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '缩图',
                        field: 'w__hisWarrant',
                        component: 'preview-image-component'
                    },
                    {
                        label: '操作',
                        opts:[
                            {
                                label: '出入库明细',
                                class: 'el-icon-s-order',
                                clickHandler: (index, row)=> {
                                   this.dialogVisible = true
                                    xhr.getHisWarrantTxDetail(
                                        Object.assign(
                                    {
                                        'de.hisWarrantNo': row.w__hisWarrantNo,
                                        't.applicationStatus':'Approved'
                                    }
                                    , {}, {}),
                                        res=> {
                                            try {
                                                this.planData = res.data
                                            }catch(e){

                                            }
                                        })
                                }
                            },
                        ]
                    }
                ],
                columns1:[
                    {
                        type: 'index'
                    },
                    {
                        label: '出入库单号',
                        field: 't__applicationNo'
                    },
                    {
                        label: '出入库类型',
                        field: 't__applicationTypeCode',
                        formatter: function (r,c,v) {
                            return Status2CN(v)
                        }
                    },
                    {
                        label: '出入库原因',
                        field: 't__reason'
                    },
                    {
                        label: '申请时间',
                        field: 't__applicationDate',
                        formatter: function (r,c,v) {
                            return moment(v).format('YYYY-MM-DD')
                        }
                    },
                ],
                tableData: {
                    count: 0,
                    data: []
                },
                planData: {
                    count: 0,
                    data: []
                },
                page: 1,
                pageSize: 20,
                actions: [
                ],
                filters: {
                    labelWidth: '150px',
                    form: {
                        w__hisWarrantNo:'',
                        w__transactionNo:'',
                        w__customerName:'',
                        w__checkoutTime:[],
                    },
                    columns: [
                        {
                            label: '他项权证号',
                            component: 'el-input',
                            field: 'w__hisWarrantNo'
                        },
                        {
                            label: '贷款编号',
                            component: 'el-input',
                            field: 'w__transactionNo'
                        },
                        {
                            label: '客户姓名',
                            component: 'el-input',
                            field: 'w__customerName'
                        },
                        {
                            label: '出/入库日期',
                            component: 'date-range-picker',
                            field: 'w__checkoutTime',
                            op: ['gteq', 'lteq'],
                            span: 12
                        },



                    ],
                    onSubmit:()=>{
                        this.page = 1
                        this.getData()
                    }
                }
            }
        },
        mounted() {
            this.getData()
        },
        computed: {
            filterParams() {
                return {
                    pageSize: this.pageSize,
                    pageOffset: (this.page - 1) * this.pageSize,
                    'xlist.search.w.status' : this.status,
                    'xlist.search.w.status.op' : 'in',
                    'xlist.sort.dataField': this.status=='IN' ? 'w.receivingTime' : 'w.checkoutTime',
                    'xlist.sort.order': 'desc',
                }
            }
        },
        watch: {
            filterParams: function (newVal) {
                this.getData()
            }
        },
        methods: {
            getData: function () {
                if(this.status=='IN'){
                    this.columns[4].label=' 入库日期'
                    this.columns[4].field='w__receivingTime'
                    this.filters.columns[3].label='入库日期'
                    this.filters.columns[3].field='w__receivingTime'
                    this.filterParams
                }else{
                    this.columns[4].label=' 出库日期'
                    this.columns[4].field='w__checkoutTime'
                    this.filters.columns[3].label='出库日期'
                    this.filters.columns[3].field='w__checkoutTime'
                }
                xhr.getHisWarrantList(
                    Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
                    res=> {
                        try {
                            this.tableData = res.data
                        }catch(e){

                        }
                    })

            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/HisWarrantList.vue